<section>
    <div class="secondaryBackgroundColor pt-5 mt-5">
        <h1 class="mb-4 text-center" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
            Payment
        </h1>
    </div>
    <div *ngIf="Amount!==0">
        <div class="container p-5 main-container mb-5 primaryBackgroundColor" *ngIf="beforeSuccess">
            <div class="row no-gutters justify-content-center p-5 main-container secondaryBackgroundColor">
                <div class="col-md-5 appointmentInfo" *ngIf="AppointmentDetails && AppointmentDetails.PaidStatus===0">
                    <ul role="list" style="list-style: none;" class="pl-0">
                        <li>
                            <h5>Type:</h5>
                            <p class="btn">Private</p>
                        </li>
                        <li>
                            <h5>Reason:</h5>
                            <p class="btn">{{AppointmentDetails.Reason}}</p>
                        </li>
                        <li>
                            <h5>With:</h5>
                            <p class="btn">{{AppointmentDetails.StaffName}}</p>
                        </li>
                        <li>
                            <h5>On</h5>
                            <p class="btn">
                                <span>{{AppointmentDetails.Date}} </span>
                                <span> at {{AppointmentDetails.SlotTime}}</span>
                            </p>
                        </li>
                        <li>
                            <h5>For</h5>
                            <p class="btn">
                                <span>{{AppointmentDetails.SlotDuration}} mins</span>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="col-md-7" *ngIf="AppointmentDetails && AppointmentDetails.PaidStatus===0">
                    <div class="d-flex row">
                        <p class="col-md-3">Fees</p>
                        <span class="col-md-1 d-none d-md-block"> : </span>
                        <h5 class="col-md-8">£ {{Amount}}</h5>
                    </div>
                    <div class="mt-3 row mx-0 align-items-center justify-content-start w-100">
                        <a class="btn btn-primary mr-2 text-white btn-m-0" aria-label="Proceed To Pay"
                            id="proceedToPay"></a>
                        <a class="btn m-0 btn-primary text-white" aria-label="Cancel" routerLink="/">Cancel</a>
                    </div>
                </div>
                <div *ngIf="AppointmentDetails && AppointmentDetails.PaidStatus===1">
                    <div class="container p-5 main-container mb-5 primaryBackgroundColor">
                        <h3 class="primaryColor text-center mb-3 mt-3">
                            <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="25" width="25" alt="right">
                            Congratulations!!! Your appointment has been booked successfully.
                        </h3>
                    </div>
                </div>
                <div *ngIf="!AppointmentDetails || AppointmentDetails && AppointmentDetails.length===0">
                    <h4 class="text-center">No Information Found. Please try later</h4>
                </div>
            </div>

        </div>

        <div class="container p-5 main-container mb-5 primaryBackgroundColor" *ngIf="!beforeSuccess">
            <h3 class="text-center">Appointment Details</h3>

            <h3 class="primaryColor text-center mb-3 mt-3">
                <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="25" width="25" alt="right">
                Congratulations!!! Your appointment payment has been done successfully.
            </h3>

            <div class="row no-gutters justify-content-center p-5 main-container secondaryBackgroundColor">
                <div class="col-md-4 mt-auto mb-auto text-center">
                    <img loading="lazy" src="{{videoCdnUrl}}images/Smile_Orchard_Logo.svg" class="col-md-10 text-center"
                        alt="logo">
                </div>
                <div class="col-md-8 appointmentInfo" *ngIf="AppointmentDetails">
                    <ul role="list" style="list-style: none;" class="pl-0">
                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">Type</p>
                            <span class="col-sm-1 d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">Private
                            </h5>
                        </li>
                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">Reason</p>
                            <span class="col-sm-1  d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">{{AppointmentDetails.Reason}}
                            </h5>
                        </li>
                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">With </p>
                            <span class="col-sm-1 d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">{{AppointmentDetails.StaffName}}
                            </h5>
                        </li>
                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">On </p>
                            <span class="col-sm-1 d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">
                                <span>{{AppointmentDetails.Date}} </span>
                                <span> at {{AppointmentDetails.SlotTime}}</span>
                            </h5>
                        </li>
                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">For </p>
                            <span class="col-sm-1 d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">
                                <span>{{AppointmentDetails.SlotDuration}} mins</span>
                            </h5>
                        </li>

                        <li class="d-flex align-items-center row">
                            <p class="mb-0 col-sm-3">Fees </p>
                            <span class="col-sm-1 d-none d-md-block"> : </span>
                            <h5 class="ml-2 mb-1 col-sm-6 btn">
                                £ {{Amount}}
                            </h5>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="text-right mt-3 mb-3">
                <a class="btn btn-primary m-2" aria-label="OK" routerLink="/">OK</a>
            </div>
        </div>
    </div>

    <div *ngIf="Amount===0">
        <div class="container p-5 main-container mb-5 primaryBackgroundColor">
            <h3 class="primaryColor text-center mb-3 mt-3">
                <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="25" width="25" alt="right">
                Congratulations!!! Your appointment has been booked successfully.
            </h3>
        </div>
    </div>
</section>